import { OTP_LENGTH } from "../../Utils/Contant";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  AudFlag,
  BGPFlag,
  CadFlag,
  EuroFlag,
  SGDFlag,
  usFlag,
  indiaFlag,
} from "../../Public/assets/index";
import React, {
  useContext,
  createContext,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import {
  checkPartnerHealth,
  CountryList,
  deleteBeneficiary,
  getBeneficiaryDetails,
  getCardDetails,
  getPartnerWallet,
  globalAccount,
  TransactionDetails,
  WalletAccount,
} from "./../../api";
import { formatCurrency } from "./../../Utils/helperFunction";
import { getSession } from "./../../axios.config";

const overviewContext = createContext(undefined);

export const useOverview = () => useContext(overviewContext);

function useProvideAccountOverview() {
  const queryClient = useQueryClient();
  const [beneficiarySelected, setBeneficiarySelected] = useState({});
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedMethodToTransfer, setSelectedMethodToTransfer] =
    useState("LOCAL");
  const [fromAmountConversionError, setFromAmountConversionError] =
    useState("");
  const [noPayment, setNoPayment] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [transactionCurrencyFilter, setTransactionCurrencyFilter] =
    useState("All");
  const [data, setData] = useState([]);
  const [amount, setAmount] = useState(null);
  const [toAmount, setToAmount] = useState(null);
  const [transferCurrency, setTransferCurrency] = useState(null);
  const [transferToCurrency, setTransferToCurrency] = useState(null);
  const [countryList, setCountryList] = useState(null);
  const [charges, setCharges] = useState({
    totalFees: "-",
    rate: 0,
  });
  const [partnerHealthDisable, setPartnerHealth] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const [isLoadingTransfer, setisLoadingTransfer] = useState(false);

  const [pinError, setPinError] = useState("");
  const [remarkError, setRemarkError] = useState("");
  const [purposeError, setPurposeError] = useState("");
  const [BenificaryData, setBenificaryData] = useState({});
  const [pin, setPin] = useState(Array(OTP_LENGTH).fill(""));
  const [challengeId, setChallengeId] = useState("");
  const [fromAmountError, setFromAmountError] = useState("");
  const [toAmountError, setToAmountError] = useState("");
  const [investmentAccount, setInvestmentAccount] = useState("");
  const [isHedgeFundAccount, setIsHedgeFundAccount] = useState("");

  const [formattedFields, setFormattedFields] = useState([]);
  const [purposeOfTransfer, setPurposeOfTransfer] = useState("");
  const [remarks, setRemarks] = useState("");
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [beniCreationError, setBeniCreationError] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const useWalletDetails = () => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["uniqueWalletDetails"],
      queryFn: WalletAccount,
      enabled: !!getSession("accessToken"),
      // cacheTime: 0,
    });
    return { isLoading, isError, data, error };
  };

  const usePartnerHealth = () => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["partnerHealth"],
      queryFn: checkPartnerHealth,
    });
    return { isLoading, isError, data, error };
  };

  const useCardDetails = () => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["cardDetails"],
      queryFn: getCardDetails,
      enabled: !!getSession("accessToken"),
    });
    return { isLoading, isError, data, error };
  };

  const usePartnerWallet = () => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["partnerWallet"],
      queryFn: () => getPartnerWallet(),
      enabled: !!getSession("accessToken"),
    });
    return { isLoading, isError, data, error };
  };

  const { data: walletData } = useWalletDetails();

  const [selectedCurrency, setSelectedCurrency] = useState(
    walletData?.data?.accounts?.[0]
  );
  const [selectedToCurrency, setSelectedToCurrency] = useState(
    walletData?.data?.accounts?.[1]
  );

  const [stateVariable, setStateVariable] = useState(1);
  const [currentFlow, setCurrentFlow] = useState("SendMoney");

  const currencies = [
    { code: "USD", countryCode: "US", name: "US Dollar", flag: usFlag },
    { code: "GBP", countryCode: "UK", name: "British Pound", flag: BGPFlag },
    { code: "SGD", countryCode: "SG", name: "Singapore Dollar", flag: SGDFlag },
    { code: "CAD", countryCode: "CA", name: "Canadian Dollar", flag: CadFlag },
    { code: "EUR", countryCode: "EU", name: "Euro", flag: EuroFlag },
    { code: "AUD", countryCode: "AU", name: "Euro", flag: AudFlag },
  ];

  const beniCurrencies = [
    { code: "INR", countryCode: "INR", name: "Indian Rupees", flag: indiaFlag },
    { code: "USD", countryCode: "US", name: "US Dollar", flag: usFlag },
    { code: "GBP", countryCode: "UK", name: "British Pound", flag: BGPFlag },
    { code: "SGD", countryCode: "SG", name: "Singapore Dollar", flag: SGDFlag },
    { code: "CAD", countryCode: "CA", name: "Canadian Dollar", flag: CadFlag },
    { code: "EUR", countryCode: "EU", name: "Euro", flag: EuroFlag },
    { code: "AUD", countryCode: "AU", name: "Euro", flag: AudFlag },
  ];

  const getFlagByCurrencyCodeForBeni = (currencyCode) => {
    const currency = beniCurrencies.find((c) => c.code === currencyCode);
    if (currency) {
      return currency.flag;
    }

    const fallbackCode = currencyCode;
    return `https://prod-assets.stockal.com/flags/${fallbackCode}.svg`;

  };

  const getFlagByCountryCode = (currencyCode) => {
    const currency = currencies.find((c) => c.countryCode === currencyCode);
    if (currency) {
      return currency.flag;
    }
    const fallbackCode = currencyCode;
    return `https://prod-assets.stockal.com/flags/${fallbackCode}.svg`;
  };

  const getFlagByCurrencyCode = (currencyCode) => {
    const currency = currencies.find((c) => c.code === currencyCode);
    return currency ? currency.flag : null;
  };

  const getCurrencyFullName = (code) => {
    const names = {
      USD: "United States Dollars",
      EUR: "Euros",
      GBP: "British Pounds",
      CAD: "Canadian Dollars",
      AUD: "Australian Dollars",
      SGD: "Singapore Dollars",
    };
    return names[code] || code;
  };

  const mainCurrencies = walletData?.data?.accounts
    ?.filter((account) => account.balance > 0)
    .map((account) => ({
      flag: getFlagByCurrencyCode(account.vendorCurrency),
      amount: formatCurrency(account?.balance - account?.holdBalance),
      currency: account.vendorCurrency,
      fullName: getCurrencyFullName(account.vendorCurrency),
    }));

  const smallCurrencies = walletData?.data?.accounts
    ?.filter((account) => account.balance === "0.00" || account.balance === 0)
    .map((account) => ({
      flag: getFlagByCurrencyCode(account.vendorCurrency),
      amount: account.balance,
      currency: account.vendorCurrency,
    }));

  // react Query code
  const useGlobalAccount = (noToggle = true) => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["globalAccount"],
      enabled: !!getSession("accessToken") && noToggle,
      // &&
      // JSON.parse(getSession("userId"))?.status === "APPROVED",
      cacheTime: 0,

      queryFn: globalAccount,
    });
    return { isLoading, isError, data, error };
  };

  const useCountryList = () => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["countryList"],
      queryFn: CountryList,
      enabled: !!getSession("accessToken"),
      onSuccess: (data) => {
        setCountryList(data?.data);
      },
    });
    return { isLoading, isError, data, error };
  };

  const useTransactionDetails = ({ type } = {}) => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["transactionDetails", { type }],
      queryFn: () => TransactionDetails({ type }),
      // cacheTime: 0,
    });
    return { isLoading, isError, data, error };
  };

  const useBeneficiaryDetails = ({
    status = undefined,
    beneficiaryId = undefined,
  }) => {
    const { isLoading, isError, data, error } = useQuery({
      queryKey: ["beneficiaryDetails", { status, beneficiaryId }],
      queryFn: ({ queryKey }) => getBeneficiaryDetails(queryKey),
      enabled: !!getSession("accessToken"),
    });
    return { isLoading, isError, data, error };
  };

  const validateAmount = (inputAmount, balance, charges, minAmount = 0) => {
    const parsedAmount = Number(inputAmount) || 0;
    const parsedBalance = Number(balance) || 0;
    const parsedCharges = Number(charges) || 0;
    const totalDeduction = parsedAmount + parsedCharges;
    // Check if amount is a valid number
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      return "Please enter a valid amount";
    }

    if (minAmount > 0 && parsedAmount < minAmount) {
      return `Amount must be greater than ${minAmount}`;
    }

    // Check if amount exceeds balance
    if (parsedAmount > parsedBalance) {
      return `Amount cannot be greater than available balance (${balance} ${selectedCurrency?.vendorCurrency})`;
    }

    if (totalDeduction > balance) {
      return ` Sum of transfer amount and transfer fee cannot be greater than available balance (${balance} ${selectedCurrency?.vendorCurrency})`;
    }

    return "";
  };

  const usePollingBeneficiaryCheck = (
    beneficiaryId,
    onStatusChange,
    onManualReview
  ) => {
    const [pollingInterval, setPollingInterval] = useState(5000);
    const [shouldPoll, setShouldPoll] = useState(true);
    const pollingAttempts = useRef(0);
    const previousBeneficiaryId = useRef(beneficiaryId);

    // Reset polling when beneficiaryId changes or explicitly called
    const resetPolling = useCallback(() => {
      setPollingInterval(5000);
      setShouldPoll(true);
      pollingAttempts.current = 0;
    }, []);

    // Reset when beneficiaryId changes
    useEffect(() => {
      if (beneficiaryId !== previousBeneficiaryId.current) {
        resetPolling();
        previousBeneficiaryId.current = beneficiaryId;
      }
    }, [beneficiaryId, resetPolling]);

    const { data, refetch, ...rest } = useQuery({
      queryKey: ["beneficiaryCheck", { beneficiaryId }],
      queryFn: () =>
        getBeneficiaryDetails(["beneficiaryCheck", { beneficiaryId }]),
      enabled: !!beneficiaryId && shouldPoll,
      refetchInterval: shouldPoll ? pollingInterval : false,
      onSuccess: (data) => {
        pollingAttempts.current += 1;

        // Destructure with default values to prevent undefined errors
        const { status = "", errorMsg = "" } = data?.data || {};
        // console.log(
        //   pollingAttempts.current,
        //   "pollingAttempts.current",
        //   pollingInterval
        // );

        switch (status) {
          case "APPROVED": {
            queryClient.invalidateQueries({ queryKey: ["beneficiaryDetails"] });
            onStatusChange();
            setSelectedMethodToTransfer(data?.data?.beniConfigCountry?.method);
            setShouldPoll(false);
            pollingAttempts.current = 0;
            break;
          }

          case "REJECTED": {
            setShouldPoll(false);
            setBeniCreationError(errorMsg);
            setisLoadingTransfer(false);
            pollingAttempts.current = 0;
            break;
          }

          case "MANUAL_REVIEW": {
            setShouldPoll(false);
            pollingAttempts.current = 0;
            queryClient.invalidateQueries({ queryKey: ["beneficiaryDetails"] });
            onManualReview?.(data?.data);
            break;
          }

          default:
            // Increase polling interval after first attempt
            if (pollingInterval === 5000) {
              setPollingInterval(10000);
            }

            // Stop polling after maximum attempts
            if (pollingAttempts.current >= 4) {
              pollingAttempts.current = 0;
              setShouldPoll(false);
              onStatusChange();
              setBeniCreationError("Verification timed out. Please try again.");
              setisLoadingTransfer(false);
            }
            break;
        }
      },
      onError: (error) => {
        console.error("Beneficiary check failed:", error);
        // Only stop polling on critical errors
        if (error?.response?.status >= 500) {
          pollingAttempts.current = 0;
          setShouldPoll(false);
          setBeniCreationError("Server error occurred. Please try again.");
          setisLoadingTransfer(false);
        }
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
    });

    return {
      ...rest,
      data,
      refetch: () => {
        resetPolling();
        return refetch();
      },
    };
  };

  const handleConfirmDelete = async () => {
    if (selectedBeneficiary) {
      try {
        setDeleting(true);
        await deleteBeneficiary(selectedBeneficiary?.beneficiaryId);
        setIsDeleteModalOpen(false);

        setDeleting(false);
        setSelectedBeneficiary(null);
        queryClient.invalidateQueries({
          queryKey: ["beneficiaryDetails"],
        });
      } catch (error) {
        setDeleting(false);
        setIsDeleteModalOpen(false);
        console.error("Error deleting beneficiary:", error);
      }
    }
  };

  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedBeneficiary(null);
  };

  const handleDeleteClick = (beneficiary, e) => {
    e.stopPropagation();
    setSelectedBeneficiary(beneficiary);
    setIsDeleteModalOpen(true);
  };

  return {
    loading,
    setLoading,

    noPayment,
    setNoPayment,
    isOpen,
    setIsOpen,
    activeTab,
    setActiveTab,
    transactionCurrencyFilter,
    setTransactionCurrencyFilter,
    currencies,
    getFlagByCurrencyCode,
    getFlagByCountryCode,
    mainCurrencies,
    smallCurrencies,
    data,
    setData,
    selectedMethod,
    setSelectedMethod,
    stateVariable,
    setStateVariable,
    currentFlow,
    setCurrentFlow,
    amount,
    setAmount,
    toAmount,
    setToAmount,
    charges,
    setCharges,
    selectedCurrency,
    setSelectedCurrency,
    selectedToCurrency,
    setSelectedToCurrency,
    transferCurrency,
    setTransferCurrency,
    transferToCurrency,
    setTransferToCurrency,
    setCountryList,
    countryList,
    formattedFields,
    setFormattedFields,
    purposeOfTransfer,
    setPurposeOfTransfer,
    remarks,
    setRemarks,
    pin,
    setPin,
    challengeId,
    setChallengeId,
    beneficiarySelected,
    setBeneficiarySelected,
    investmentAccount,
    setInvestmentAccount,
    selectedDuration,
    setSelectedDuration,
    isHedgeFundAccount,
    setIsHedgeFundAccount,

    // react query
    usePollingBeneficiaryCheck,
    useGlobalAccount,
    useCountryList,
    useTransactionDetails,
    useWalletDetails,
    useBeneficiaryDetails,
    useCardDetails,
    usePartnerWallet,
    // TransferFundsToBeneficiary,
    selectedMethodToTransfer,
    setSelectedMethodToTransfer,
    BenificaryData,
    setBenificaryData,
    fromAmountConversionError,
    setFromAmountConversionError,
    isLoadingTransfer,
    setisLoadingTransfer,
    setBeniCreationError,
    beniCreationError,

    fromAmountError,
    setFromAmountError,
    toAmountError,
    setToAmountError,
    remarkError,
    setRemarkError,
    pinError,
    setPinError,
    validateAmount,
    isLoading,
    setIsLoading,
    getFlagByCurrencyCodeForBeni,
    // DeleteBenifciary model
    handleCloseModal,
    selectedBeneficiary,
    setSelectedBeneficiary,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleConfirmDelete,
    handleDeleteClick,
    deleting,
    setDeleting,
    purposeError,
    setPurposeError,
    usePartnerHealth,
    partnerHealthDisable,
    setPartnerHealth,
  };
}

export function ProvideAccountOverview({ children }) {
  const overview = useProvideAccountOverview();
  return (
    <overviewContext.Provider value={overview}>
      {children}
    </overviewContext.Provider>
  );
}
